module.exports = __webpack_public_path__ + "assets/img/deactivate2.207681bf.png";